export default "__VITE_ASSET__CfLYYt7W__"